import styled from 'styled-components';

export const HoursDropdownContainer = styled.div`
    background-color: ${props => props.hoursBgColor};
`;
